<script lang="ts" setup>
import type { Brand } from '~/types/Brand';

definePageMeta({ breadcrumb: 'Бренды' });
useHead({ title: 'Бренды – Hellride.ru' });

const brands = ref<Brand[]>([]);

const catalogStore = useCatalogStore();
brands.value = await catalogStore.getBrands();
</script>

<template>
  <section class="brands-page">
    <BreadcrumbsBlock />

    <h1>Бренды</h1>

    <p class="text-sm sm:text-base">
      Hellride.ru — официальный дилер представленных торговых марок. Это значит, что продукция фирменная (никакого
      «серого импорта»), на товары распространяется гарантия производителя, а цены соответствуют рекомендованным.
    </p>

    <div
      v-if="brands.length"
      class="brands-page__items-grid"
    >
      <AppLink
        v-for="brand in brands"
        :key="brand.slug"
        :to="brand.uri"
      >
        <BrandLogoBlock
          :brand="brand"
          show-title
        />
      </AppLink>
    </div>

    <div
      v-else
      class="flex justify-center items-center w-full h-64 text-lg text-hell-black-60 text-center"
    >
      Бренды не найдены...
    </div>
  </section>
</template>

<style lang="scss" scoped>
.brands-page {
  @include inner-content;

  gap: 16px;

  &__items-grid {
    display: grid;
    grid-template-columns: repeat(4, auto);
    gap: 8px;
    justify-content: space-between;

    @include screen-xs {
      grid-template-columns: repeat(6, auto);
    }

    @include screen-md {
      grid-template-columns: repeat(7, auto);
      gap: 16px;
    }

    @include screen-lg {
      grid-template-columns: repeat(10, auto);
    }

    @include screen-xl {
      grid-template-columns: repeat(12, auto);
    }
  }
}
</style>
